import {IS_OFFLINE_MODE} from "../config";

export const baseDashboardImagesPath = document.kvConfig.kioskMode ? './images/dashboard/images/icons/pj-scope-icons/enabled/' : ((location.port === '9007')
  ? 'http://quotekandb.com/content/Views/dashboard/images/icons/pj-scope-icons/enabled/'
  : '/content/Views/dashboard/images/icons/pj-scope-icons/enabled/');

// let isHttpBNIP = baseNewImagesPath.length > 4 && baseNewImagesPath.substring(0, 4).toLowerCase() == "http";
const isLocal = (document.kvConfig.kioskMode || document.kvConfig.noInternetMode || location.port === '9007');
export const baseAssetsPath = isLocal
  ? './'
  : (document.querySelectorAll('link')[0].href.substring(0, document.querySelectorAll('link')[0].href.indexOf('/visualizers/') + "/visualizers/".length));
  // : '/content/Views/visualizers/';

export const serverAssetsPath = '/content/Views/visualizers/';

export const baseNewImagesPath = isLocal
  ? baseAssetsPath
  : IS_OFFLINE_MODE ? serverAssetsPath : baseAssetsPath + "styles/"
